export const MemberTechName = 'クラウドワークス テック'
export const SeoMemberTechCompanyName = 'クラウドワークス テック（旧クラウドテック）'
